<template>
    <div>
        <h1>{{ trans('step1.h1','Premium ski rentals,') }} <span>{{ trans('step1.h1span','delivered to you.') }}</span></h1>

        <p class="para">
            {{ trans('step1.description', 'Free delivery. In-room fitting. Slopeside service. Seamless return.') }}
        </p>


        <!--        <booking-flayer :from-wp="false"/>-->
        <new-booking-flayer class="m-t-100" :from-wp="false"/>
    </div>

</template>
<script>
// import BookingFlayer from "../../layouts/BookingFlayer";
import {mapState} from "vuex";
import NewBookingFlayer from "../../layouts/NewBookingFlayer";

export default {
    props: {'url_code': null},
    name: 'Step1',
    components: {NewBookingFlayer},
    created(){
        this.$store.dispatch('setStep1Params', window.location.search)

        if(this.url_code){
            this.$store.dispatch('fetchPortalData', {'url_code': this.url_code});
        }
    },
    mounted() {
        document.body.classList.remove('bg-body-light')
        document.body.classList.add('bg-gray')
        console.log(this.$i18n.locale); // Should output the current locale, e.g., 'en'
        console.log(this.$t('step1.h1')); // Should output the translated message
    },
    methods: {
        trans(key, defaultValue,msg=null) {
            let translation = '';
            if(msg){
                translation = this.$t(key,{message:msg});
            }else{
                translation = this.$t(key);
            }
            return translation !== key ? translation : defaultValue;
        },
    },
    computed:{
        ...mapState(['portal']),
    }
}
</script>
